/**
 * Shared helper: inclusive attending headcount for an event card
 * (members + their +1 guests). Used wherever we show "N attending".
 *
 * Named without the `use` prefix so ESLint doesn't flag it as a hook —
 * it's a pure function, safe inside map() callbacks and render props.
 */
export const calcHeadcount = (event) => {
  if (!event) return 0;
  const members = event.attendees?.length || 0;
  const guests = event.guest_counts
    ? Object.values(event.guest_counts).reduce(
        (a, v) => a + (parseInt(v) || 0),
        0
      )
    : 0;
  return members + guests;
};

export default calcHeadcount;
